type IOptionInfo = IReport.IOptionInfo;

export const changeTypeOption = (
  item: { typeId: string; typeName: string | null },
  values: string[],
  options: IOptionInfo[],
) => {
  if (!values.includes(item.typeId)) {
    options.push({
      text: item.typeName || item.typeId,
      value: item.typeId,
    });
    values.push(item.typeId);
  }
};

export const changeOwnerOption = (
  item: { owner: string; followName: string | null },
  values: string[],
  options: IOptionInfo[],
) => {
  if (!values.includes(item.owner)) {
    options.push({
      text: item.followName || item.owner,
      value: item.owner,
    });
    values.push(item.owner);
  }
};
export const changeStatusOption = (
  item: { status: string },
  values: string[],
  options: IOptionInfo[],
) => {
  if (!values.includes(item.status)) {
    options.push({
      text: item.status,
      value: item.status,
    });
    values.push(item.status);
  }
};
export const changeCreatorOption = (
  item: { createdBy: string; createdName: string },
  values: string[],
  options: IOptionInfo[],
) => {
  if (!values.includes(item.createdBy)) {
    options.push({
      text: item.createdName || item.createdBy,
      value: item.createdBy,
    });
    values.push(item.createdBy);
  }
};
export const changeSettlementUnitOption = (
  item: { settlementConfigurationName: string | null },
  values: string[],
  options: IOptionInfo[],
) => {
  if (!values.includes(item.settlementConfigurationName || 'NULL')) {
    options.push({
      text: item.settlementConfigurationName || 'NULL',
      value: item.settlementConfigurationName || 'NULL',
    });
    values.push(item.settlementConfigurationName || 'NULL');
  }
};
export const changeQuotationCategoryOption = (
  item: { quotationCategoryNames: string[] },
  values: string[],
  options: IOptionInfo[],
) => {
  if (item.quotationCategoryNames.length === 0 && !values.includes('NULL')) {
    options.push({
      text: 'NULL',
      value: 'NULL',
    });
    values.push('NULL');
  } else {
    item.quotationCategoryNames.forEach((quotationCategory) => {
      if (!values.includes(quotationCategory)) {
        options.push({
          text: quotationCategory,
          value: quotationCategory,
        });
        values.push(quotationCategory);
      }
    });
  }
};

export const changeSettlementUnitOptionByArray = (
  item: { settlementConfigurationNames: string[] },
  values: string[],
  options: IOptionInfo[],
) => {
  if (
    item.settlementConfigurationNames.length === 0 &&
    !values.includes('NULL')
  ) {
    options.push({
      text: 'NULL',
      value: 'NULL',
    });
    values.push('NULL');
  } else {
    item.settlementConfigurationNames.forEach((settlementUnit) => {
      if (!values.includes(settlementUnit)) {
        options.push({
          text: settlementUnit,
          value: settlementUnit,
        });
        values.push(settlementUnit);
      }
    });
  }
};
